function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediocre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.7,
    height: 195.7,
    viewBox: "0 0 195.7 195.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.85,195.7A97.85,97.85,0,1,1,195.7,97.85,97.85,97.85,0,0,1,97.85,195.7Zm0-185.7A87.85,87.85,0,1,0,185.7,97.85,87.85,87.85,0,0,0,97.85,10Z",
    transform: "translate(0 0)",
    style: {
      fill: "#ff9100"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.49,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#ff9100"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.42,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#ff9100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.06,
    y: 126.95,
    width: 119.35,
    height: 10,
    style: {
      fill: "#ff9100"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediocre);
export default __webpack_public_path__ + "static/media/mediocre.6638b29b5d70bb0d074a226424b3b1de.svg";
export { ForwardRef as ReactComponent };